import * as React from 'react'
import { cn } from '../../lib/utils'

export interface LogoProps {
	size?: 'sm' | 'md' | 'lg'
	className?: string
	showText?: boolean
}

const sizeMap = {
	sm: { icon: 24, text: 'text-base' },
	md: { icon: 32, text: 'text-xl' },
	lg: { icon: 40, text: 'text-2xl' },
}

const Logo = React.forwardRef<HTMLDivElement, LogoProps>(
	({ size = 'md', className, showText = true }, ref) => {
		const { icon, text } = sizeMap[size]

		return (
			<div ref={ref} className={cn('flex items-center gap-2.5', className)}>
				<svg
					width={icon}
					height={icon}
					viewBox="0 0 32 32"
					fill="none"
					xmlns="http://www.w3.org/2000/svg"
					aria-hidden="true"
				>
					<rect width="32" height="32" rx="8" fill="var(--color-primary)" />
					<path
						d="M8 22V14l8-6 8 6v8h-5v-5h-6v5H8z"
						fill="var(--color-primary-foreground)"
					/>
				</svg>
				{showText && (
					<span className={cn('font-semibold text-(--color-neutral-900)', text)}>
						RentFlow
					</span>
				)}
			</div>
		)
	}
)

Logo.displayName = 'Logo'

export { Logo }
